import { FC, ReactNode } from 'react';

import { Button, Flex, Text } from '@servicetitan/anvil2';

import { Content } from './content';

/**
 * Broken truck illustration for error states
 */
const BrokenTruckIllustration = () => (
    <svg
        width="180"
        height="100"
        viewBox="0 0 180 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M149.778 71.5576H145.334V91.5576H149.778V71.5576Z" fill="#0265DC" />
        <path
            d="M149.556 91.5576C155.079 91.5576 159.556 87.0805 159.556 81.5576C159.556 76.0348 155.079 71.5576 149.556 71.5576C144.033 71.5576 139.556 76.0348 139.556 81.5576C139.556 87.0805 144.033 91.5576 149.556 91.5576Z"
            fill="#0265DC"
        />
        <path
            d="M145.556 91.5576C151.079 91.5576 155.556 87.0805 155.556 81.5576C155.556 76.0348 151.079 71.5576 145.556 71.5576C140.033 71.5576 135.556 76.0348 135.556 81.5576C135.556 87.0805 140.033 91.5576 145.556 91.5576Z"
            fill="#113064"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M145.333 78.2243C143.37 78.2243 141.778 79.8162 141.778 81.7799C141.778 83.7436 143.37 85.3355 145.333 85.3355C147.297 85.3355 148.889 83.7436 148.889 81.7799C148.889 79.8162 147.297 78.2243 145.333 78.2243ZM140.889 81.7799C140.889 79.3253 142.879 77.3354 145.333 77.3354C147.788 77.3354 149.778 79.3253 149.778 81.7799C149.778 84.2345 147.788 86.2243 145.333 86.2243C142.879 86.2243 140.889 84.2345 140.889 81.7799Z"
            fill="#0265DC"
        />
        <path d="M66.6667 71.5576H62.2223V91.5576H66.6667V71.5576Z" fill="#0265DC" />
        <path
            d="M66.4445 91.5576C71.9673 91.5576 76.4445 87.0805 76.4445 81.5576C76.4445 76.0348 71.9673 71.5576 66.4445 71.5576C60.9216 71.5576 56.4445 76.0348 56.4445 81.5576C56.4445 87.0805 60.9216 91.5576 66.4445 91.5576Z"
            fill="#0265DC"
        />
        <path
            d="M62.4446 91.5576C67.9674 91.5576 72.4446 87.0805 72.4446 81.5576C72.4446 76.0348 67.9674 71.5576 62.4446 71.5576C56.9217 71.5576 52.4446 76.0348 52.4446 81.5576C52.4446 87.0805 56.9217 91.5576 62.4446 91.5576Z"
            fill="#113064"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M62.2222 78.2243C60.2585 78.2243 58.6666 79.8162 58.6666 81.7799C58.6666 83.7436 60.2585 85.3355 62.2222 85.3355C64.1858 85.3355 65.7777 83.7436 65.7777 81.7799C65.7777 79.8162 64.1858 78.2243 62.2222 78.2243ZM57.7777 81.7799C57.7777 79.3253 59.7676 77.3354 62.2222 77.3354C64.6768 77.3354 66.6666 79.3253 66.6666 81.7799C66.6666 84.2345 64.6768 86.2243 62.2222 86.2243C59.7676 86.2243 57.7777 84.2345 57.7777 81.7799Z"
            fill="#0265DC"
        />
        <path d="M146.222 81.3354H31.1112V84.4466H146.222V81.3354Z" fill="#113064" />
        <path
            d="M44.0002 77.3353C44.0002 70.153 37.9202 64.393 30.6268 64.9264C24.089 65.4019 19.1113 71.0241 19.1113 77.5841V81.7841H44.0002V77.3397V77.3353Z"
            fill="#FFB2A0"
        />
        <path d="M35.4979 71.5576H31.0534V91.5576H35.4979V71.5576Z" fill="#0265DC" />
        <path
            d="M35.2756 91.5576C40.7985 91.5576 45.2756 87.0805 45.2756 81.5576C45.2756 76.0348 40.7985 71.5576 35.2756 71.5576C29.7528 71.5576 25.2756 76.0348 25.2756 81.5576C25.2756 87.0805 29.7528 91.5576 35.2756 91.5576Z"
            fill="#0265DC"
        />
        <path
            d="M31.2757 91.5576C36.7985 91.5576 41.2757 87.0805 41.2757 81.5576C41.2757 76.0348 36.7985 71.5576 31.2757 71.5576C25.7528 71.5576 21.2757 76.0348 21.2757 81.5576C21.2757 87.0805 25.7528 91.5576 31.2757 91.5576Z"
            fill="#113064"
        />
        <path
            d="M31.0535 85.7798C33.2626 85.7798 35.0535 83.9889 35.0535 81.7798C35.0535 79.5706 33.2626 77.7798 31.0535 77.7798C28.8443 77.7798 27.0535 79.5706 27.0535 81.7798C27.0535 83.9889 28.8443 85.7798 31.0535 85.7798Z"
            fill="white"
        />
        <path
            d="M31.0535 84.0021C32.2808 84.0021 33.2757 83.0071 33.2757 81.7798C33.2757 80.5525 32.2808 79.5576 31.0535 79.5576C29.8262 79.5576 28.8313 80.5525 28.8313 81.7798C28.8313 83.0071 29.8262 84.0021 31.0535 84.0021Z"
            fill="#FFB2A0"
        />
        <path
            d="M167.111 52.8911V81.7799H127.111V77.3355C127.111 70.1533 121.031 64.3933 113.738 64.9266C107.196 65.3977 102.222 71.0244 102.222 77.5799V81.7799H44V77.3355C44 70.1533 37.92 64.3933 30.6266 64.9266C24.0844 65.3977 19.1111 71.0244 19.1111 77.5799V81.7799H8.88885V8.89106C8.88885 7.90884 9.68441 7.11328 10.6666 7.11328H137.778L139.867 11.1133L153.293 37.3355L155.556 41.7799L167.111 52.8911Z"
            fill="#0265DC"
        />
        <path
            d="M135.555 52.8911V81.7799H127.111V77.3355C127.111 70.1533 121.031 64.3933 113.738 64.9266C107.195 65.3977 102.222 71.0244 102.222 77.5799V81.7799H43.9999V77.3355C43.9999 70.1533 37.9199 64.3933 30.6266 64.9266C24.0843 65.3977 19.111 71.0244 19.111 77.5799V81.7799H8.88877L6.22211 44.8911L8.77322 8.76662C8.83989 7.83328 9.61322 7.11328 10.5466 7.11328H106.222L124 41.7799L135.555 52.8911Z"
            fill="#B5DEFF"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.6667 76.2823C14.6667 67.5119 22.2583 60.4468 31.5556 60.4468C40.8528 60.4468 48.4445 67.5073 48.4445 76.2823V81.7801H47.5556V76.2823C47.5556 68.0529 40.4184 61.3357 31.5556 61.3357C22.6929 61.3357 15.5556 68.0573 15.5556 76.2823V81.7801H14.6667V76.2823Z"
            fill="#113064"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M97.7778 76.2823C97.7778 67.5119 105.369 60.4468 114.667 60.4468C123.964 60.4468 131.556 67.5073 131.556 76.2823V81.7801H130.667V76.2823C130.667 68.0529 123.53 61.3357 114.667 61.3357C105.804 61.3357 98.6667 68.0573 98.6667 76.2823V81.7801H97.7778V76.2823Z"
            fill="#113064"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M98.2222 78.2243H48V77.3354H98.2222V78.2243Z"
            fill="#113064"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M79.5555 48.0022H11.9999V47.1133H79.5555V48.0022Z"
            fill="#113064"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M91.1111 43.5578H83.1111V42.6689H91.1111V43.5578Z"
            fill="#113064"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M79.1111 81.7799V11.1133H80V81.7799H79.1111Z"
            fill="#113064"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.2804 44.887L13.6129 11.1308L12.7247 11.0957L11.3905 44.8951L12.7251 68.0277L13.6125 67.9765L12.2804 44.887Z"
            fill="#113064"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.7779 68.0022H7.55566V67.1133H17.7779V68.0022Z"
            fill="#113064"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M104.191 12.0022H8.88885V11.1133H104.733L120.444 41.6724V61.7799H119.556V41.8875L104.191 12.0022Z"
            fill="#113064"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.9999 11.1133H72.4443V40.4466H19.9999V11.1133ZM20.8888 12.0022V39.5577H71.5554V12.0022H20.8888Z"
            fill="#113064"
        />
        <path
            d="M64.0001 16.8911H28.889C27.9071 16.8911 27.1112 17.6871 27.1112 18.6689V32.8911C27.1112 33.873 27.9071 34.6689 28.889 34.6689H64.0001C64.9819 34.6689 65.7779 33.873 65.7779 32.8911V18.6689C65.7779 17.6871 64.9819 16.8911 64.0001 16.8911Z"
            fill="white"
        />
        <path
            d="M84.8889 14.6689H100.689C101.356 14.6689 101.969 15.0423 102.271 15.6378L113.333 37.3356H84.8889C83.9067 37.3356 83.1111 36.5401 83.1111 35.5578V16.4467C83.1111 15.4645 83.9067 14.6689 84.8889 14.6689Z"
            fill="#113064"
        />
        <path
            d="M127.111 77.3353C127.111 70.153 121.031 64.393 113.738 64.9264C107.2 65.4019 102.222 71.0241 102.222 77.5841V81.7841H127.111V77.3397V77.3353Z"
            fill="#FFB2A0"
        />
        <path
            d="M153.24 37.3355H125.28L112.276 11.7577C112.124 11.4599 112.342 11.1133 112.671 11.1133H139.813L153.24 37.3355Z"
            fill="#113064"
        />
        <path
            d="M34.8313 65.3444C29.5113 66.8377 25.7202 71.8555 25.7202 77.5799V81.7799H19.0535V77.5666C19.0535 71.0288 24.0046 65.4199 30.5202 64.931C32.0224 64.8155 33.4713 64.9666 34.8313 65.3444Z"
            fill="#113064"
        />
        <path d="M167.111 52.8911H135.556V81.78H167.111V52.8911Z" fill="#0265DC" />
        <path
            d="M117.942 65.3444C112.622 66.8377 108.831 71.8555 108.831 77.5799V81.7799H102.164V77.5666C102.164 71.0288 107.115 65.4199 113.631 64.931C115.133 64.8155 116.582 64.9666 117.942 65.3444Z"
            fill="#113064"
        />
        <path
            d="M114.164 88.8912C118.092 88.8912 121.275 85.7074 121.275 81.7801C121.275 77.8527 118.092 74.6689 114.164 74.6689C110.237 74.6689 107.053 77.8527 107.053 81.7801C107.053 85.7074 110.237 88.8912 114.164 88.8912Z"
            fill="#113064"
        />
        <path
            d="M114.164 85.7803C116.374 85.7803 118.164 83.9894 118.164 81.7803C118.164 79.5711 116.374 77.7803 114.164 77.7803C111.955 77.7803 110.164 79.5711 110.164 81.7803C110.164 83.9894 111.955 85.7803 114.164 85.7803Z"
            fill="white"
        />
        <path
            d="M114.164 84.0021C115.391 84.0021 116.386 83.0071 116.386 81.7798C116.386 80.5525 115.391 79.5576 114.164 79.5576C112.937 79.5576 111.942 80.5525 111.942 81.7798C111.942 83.0071 112.937 84.0021 114.164 84.0021Z"
            fill="#FFB2A0"
        />
        <g opacity="0.5">
            <path
                d="M143.542 18.3931C135.502 20.5975 129.182 27.0153 127.116 35.1131H138.96C140.889 31.5308 144.551 29.0153 148.822 28.7042L143.542 18.3931Z"
                fill="#B5DEFF"
            />
        </g>
        <path d="M124 41.7798H155.556L167.111 52.8909H135.556L124 41.7798Z" fill="#113064" />
        <path
            d="M172.067 26.0555C171.231 23.7755 174.373 22.6733 174.662 20.4866C175.102 18.4777 173.005 17.5755 171.769 16.4688C170.453 15.2199 170.556 13.3666 171.102 11.6955C171.778 9.53104 172.982 7.43771 172.396 5.34882C170.227 -0.460069 160.04 -0.993403 155.116 1.17104C148.138 3.90437 142.853 14.0377 148.858 20.131C151.378 22.7355 156.045 23.7888 159.111 22.9533C159.453 22.8822 160.333 22.5044 160.453 22.6333C160.165 23.1844 159.316 23.9266 158.867 24.6822C153.205 33.2555 168.062 33.6199 156.569 41.771C150.165 45.7844 152.387 51.5577 152.387 51.5577C159.942 45.3399 161.458 51.2022 166.347 49.6466C169.68 48.4022 170.578 44.931 169.213 41.8644C168.871 41.0022 168.631 40.2733 168.867 39.5977C169.427 38.2377 170.973 37.2244 171.818 35.9799C173.858 33.3844 174.538 30.9177 173.062 28.1399C172.733 27.491 172.307 26.7977 172.085 26.1266L172.058 26.0466L172.067 26.0555Z"
            fill="#FFB2A0"
        />
        <path d="M124 41.7798H155.556L166.667 44.8909H135.098L124 41.7798Z" fill="#0265DC" />
        <path
            opacity="0.5"
            d="M124 41.7798H155.556L166.667 44.8909H135.098L124 41.7798Z"
            fill="#B5DEFF"
        />
        <path d="M144.445 58.6689H158.667" stroke="white" strokeWidth="2" strokeMiterlimit="10" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M158.667 63.1135H144.445V62.2246H158.667V63.1135Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M158.667 67.1135H144.445V66.2246H158.667V67.1135Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M158.667 71.1135H144.445V70.2246H158.667V71.1135Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M132.889 58.6687C132.643 58.6687 132.444 58.8677 132.444 59.1131V66.2242C132.444 66.4697 132.643 66.6687 132.889 66.6687H140C140.245 66.6687 140.444 66.4697 140.444 66.2242V59.1131C140.444 58.8677 140.245 58.6687 140 58.6687H132.889ZM131.555 59.1131C131.555 58.3767 132.152 57.7798 132.889 57.7798H140C140.736 57.7798 141.333 58.3767 141.333 59.1131V66.2242C141.333 66.9606 140.736 67.5576 140 67.5576H132.889C132.152 67.5576 131.555 66.9606 131.555 66.2242V59.1131Z"
            fill="#113064"
        />
        <path d="M140.889 61.3354H132V64.0021H140.889V61.3354Z" fill="#FFB2A0" />
        <path d="M167.111 61.3354H161.333V64.0021H167.111V61.3354Z" fill="#FFB2A0" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M131.555 60.8911H141.333V64.4467H131.555V60.8911ZM132.444 61.78V63.5578H140.444V61.78H132.444Z"
            fill="#113064"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M162.667 58.6687C162.423 58.6687 162.222 58.8697 162.222 59.1131V66.2242C162.222 66.4677 162.423 66.6687 162.667 66.6687H167.111V67.5576H162.667C161.932 67.5576 161.333 66.9586 161.333 66.2242V59.1131C161.333 58.3788 161.932 57.7798 162.667 57.7798H167.111V58.6687H162.667Z"
            fill="#113064"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M161.333 60.8911H167.111V61.78H162.222V63.5578H167.111V64.4467H161.333V60.8911Z"
            fill="#113064"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M142.443 31.0789L131.776 26.6345L132.118 25.814L142.784 30.2584L142.443 31.0789Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M136.975 28.6026L137.807 28.2905L140.734 36.0945L150.869 39.5819L150.58 40.4224L140.049 36.7987L136.975 28.6026Z"
            fill="white"
        />
        <path
            d="M133.333 75.1133H169.333V81.3355C169.333 82.3177 168.538 83.1133 167.555 83.1133H135.111C134.129 83.1133 133.333 82.3177 133.333 81.3355V75.1133Z"
            fill="#113064"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M180 92.8911H0V91.1133H180V92.8911Z"
            fill="#113064"
        />
        <path
            d="M5.33319 75.1133H11.5554V83.1133H7.11097C6.12875 83.1133 5.33319 82.3177 5.33319 81.3355V75.1133Z"
            fill="#113064"
        />
        <path d="M23.4979 81.3354H11.4979V82.6688H23.4979V81.3354Z" fill="#113064" />
        <path
            d="M96 84.4468H87.1111L80.4444 90.2246V91.5579L87.1111 97.3357H96L102.667 91.5579V90.2246L96 84.4468ZM99.1111 91.5579L95.1111 94.669H88L84 91.5579V90.669L88 87.1134H95.1111L99.1111 90.669V91.5579Z"
            fill="#B5DEFF"
        />
        <path
            d="M98.6668 84.4468H89.7779L83.1112 90.2246V91.5579L89.7779 97.3357H98.6668L105.333 91.5579V90.2246L98.6668 84.4468ZM101.778 91.5579L97.7779 94.669H90.6668L86.6668 91.5579V90.669L90.6668 87.1134H97.7779L101.778 90.669V91.5579Z"
            fill="#113064"
        />
        <path
            d="M134.222 89.3354H115.555C114.574 89.3354 113.778 90.1314 113.778 91.1132V97.7799C113.778 98.7617 114.574 99.5577 115.555 99.5577H134.222C135.204 99.5577 136 98.7617 136 97.7799V91.1132C136 90.1314 135.204 89.3354 134.222 89.3354Z"
            fill="#113064"
        />
    </svg>
);

interface ErrorStateProps {
    /** The main title to display */
    title: string;
    /** The description text below the title */
    description: string;
    /** Optional callback for retry action */
    onRetry?: () => void;
    /** Optional label for retry button (defaults to "Try Again") */
    retryLabel?: string;
    /** Optional callback for back navigation */
    onGoBack?: () => void;
    /** Optional label for back button (defaults to "Back to previous page") */
    backLabel?: string;
    /** Optional custom actions to render instead of default buttons */
    actions?: ReactNode;
}

/**
 * Reusable error state component with truck illustration.
 * Displays an error message with optional retry and back navigation actions.
 */
export const ErrorState: FC<ErrorStateProps> = ({
    title,
    description,
    onRetry,
    retryLabel = 'Try Again',
    onGoBack,
    backLabel = 'Back to previous page',
    actions,
}) => {
    const renderDefaultActions = () => (
        <Flex direction="column" gap="3" style={{ width: '100%' }}>
            {onRetry && (
                <Button
                    appearance="primary"
                    size="large"
                    onClick={onRetry}
                    style={{ width: '100%' }}
                >
                    {retryLabel}
                </Button>
            )}
            {onGoBack && (
                <Button
                    appearance="secondary"
                    size="large"
                    onClick={onGoBack}
                    style={{ width: '100%' }}
                >
                    {backLabel}
                </Button>
            )}
        </Flex>
    );

    return (
        <Content justifyContent="center" alignItems="center">
            <Flex direction="column" gap="5" alignItems="center">
                <BrokenTruckIllustration />
                <Flex direction="column" gap="2" alignItems="center">
                    <Text variant="body" size="large">
                        <b>{title}</b>
                    </Text>
                    <Text variant="body" subdued style={{ textAlign: 'center' }}>
                        {description}
                    </Text>
                </Flex>
                {actions ?? renderDefaultActions()}
            </Flex>
        </Content>
    );
};
